// Variants
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const SUCCESS_PARAGRAPH_BOLD_PROPS = {
  testId: 'success-container-paragraph-bold',
  weight: VARIANTS.ParagraphWeightType.BOLD,
};

export { SUCCESS_PARAGRAPH_BOLD_PROPS };
